import { RuleCriteria } from '~/services/AccommodationService';

export function summarizeCriteria(criteria: RuleCriteria): string {
  const parts: Array<string> = [];
  if (criteria.minLengthOfStay) {
    parts.push(`Min ${criteria.minLengthOfStay} night(s)`);
  }
  if (criteria.minLeadDays) {
    parts.push(`Min ${criteria.minLeadDays} lead day(s)`);
  }
  if (criteria.boardCodes?.length) {
    parts.push(`Board: ${criteria.boardCodes.join(', ')}`);
  }
  if (criteria.refundableStatuses?.length) {
    parts.push(`Refundable: ${criteria.refundableStatuses.join(', ')}`);
  }
  if (criteria.regions?.length) {
    parts.push(`Regions: ${criteria.regions.join(', ')}`);
  }
  if (criteria.suppliers?.length) {
    parts.push(`Suppliers: ${criteria.suppliers.join(', ')}`);
  }
  if (criteria.internalServices?.length) {
    parts.push(`Services: ${criteria.internalServices.join(', ')}`);
  }
  if (criteria.checkInDaysOfWeek?.length) {
    parts.push(`Check-in days: ${criteria.checkInDaysOfWeek.length}`);
  }
  if (criteria.ratePlanIds?.length) {
    parts.push(`${criteria.ratePlanIds.length} rate plan(s)`);
  }
  if (criteria.roomIds?.length) {
    parts.push(`${criteria.roomIds.length} room(s)`);
  }
  if (criteria.supplierRateIds?.length) {
    parts.push(`${criteria.supplierRateIds.length} supplier rate(s)`);
  }
  if (criteria.occupancy) {
    parts.push('Occupancy restricted');
  }
  return parts.length > 0 ? parts.join(' · ') : 'No conditions';
}
